import { closePopup, openPopup } from '@/popups/popup';
import $ from 'jquery';

export function popupRating() {
  const $popupRating = $('#popup-rating');
  if (window.localStorage.getItem('rating-popup') !== 'yes') {
    openPopup($popupRating);
  }

  $popupRating.find('.rating-stars-select').on('change', (e) => {
    const $t = $(e.currentTarget);
    const $next = $t.parents('.rating-stars').next('.popup-rating-textarea');

    if (parseInt($t.val()) < 9) {
      $next.addClass('show');
    } else {
      $next.removeClass('show');
    }
  });

  $('.popup-rating-accept').on('click', () => {
    /*todo действия при подтверждении*/
    window.localStorage.setItem('rating-popup', 'yes'); //todo заменить на нужное действие
    closePopup($popupRating);
  });

  $('.popup-rating-dismiss').on('click', () => {
    /*todo действия при отклонении*/
    window.localStorage.setItem('rating-popup', 'yes'); //todo заменить на нужное действие
    closePopup($popupRating);
  });
}
